import React from "react";
import AuthService from "./authService.js";

class NotificationService extends React.Component {
  static GetNumberOfUnreadMessages() {
    const url = '/api/Notification/GetNumberOfUnreadMessages/?clearCache=true';

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  // Returns the unread messages flagged to be shown in a popup, and clears that flag
  // server-side so each is returned only once. The messages stay unread in the inbox.
  static GetPopupMessages() {
    const url = '/api/Notification/GetPopupMessages/?clearCache=true';

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  static GetMessageList() {
    const url = '/api/Notification/GetMessageList/?clearCache=true';

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  static GetMessagebyId(id) {
    const url = `/api/Notification/GetMessageById/${id}`;

    const authService = AuthService.getInstance();

    return authService.CallBackendFunction(url);
  }

  static DeleteMessageById(id) {
    const url = `/api/Notification/DeleteMessageById/${id}`;

    const authService = AuthService.getInstance();

    return authService.CallBackendFunctionDelete(url);
  }

  static SendMessage(message) {
    const url = '/api/Notification/SendMessage/';
    const authService = AuthService.getInstance();
    const data = JSON.stringify(message);
    return authService.CallBackendFunctionPost(url, data);
  }

  static SendMassMessage(message) {
    const url = '/api/Notification/SendMassMessage/';
    const authService = AuthService.getInstance();
    const data = JSON.stringify(message);
    return authService.CallBackendFunctionPost(url, data);
  }

  static MarkAllAsRead() {
    const url = '/api/Notification/MarkAllAsRead/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionPut(url);
  }

  static DeleteAllRead() {
    const url = '/api/Notification/DeleteAllRead/';
    const authService = AuthService.getInstance();
    return authService.CallBackendFunctionDelete(url);
  }
}

export default NotificationService;
